export const isTopDistributor = (value?: string) => {
  if (!value) {
    return false
  }

  return value === 'top-distributor'
}
